export const VOUCHER_TYPE = ['cashback', 'free-shipping', 'discount']
export default {
  VOUCHER_TYPE
}
